<script lang="ts">
	import { z } from 'zod';
	import { createForm } from 'felte';
	import { validator } from '@felte/validator-zod';

	import { getHubStores } from '$lib/stores/hubStores';
	import ButtonLink from '$lib/components/ButtonLink/ButtonLink.svelte';
	import { _ } from 'svelte-i18n';
	import HubLogo from '$lib/Signin/HubLogo.svelte';
	import { Input } from '$lib/components/Inputs';
	import Button from '$lib/components/Button/Button.svelte';
	import { validatePassword } from '$lib/utils/validations';

	export let token: string;
	export let isTokenInvalid: boolean;
	export let isResetPasswordFormDisplayed: boolean;
	export let isAUXModalRendered: boolean;
	export let onSuccess: () => void;

	const { hub, restApi } = getHubStores();

	let submitError = '';

	const schema = z.object({
		password: validatePassword(),
	});
	const { errors, form } = createForm<z.infer<typeof schema>>({
		extend: validator({ schema }),
		onSuccess: () => {
			onSuccess();
			submitError = '';
		},
		onError() {
			submitError = $_('session.password.change.error.message');
		},
	});
</script>

<div class="resetPasswordForm">
	<HubLogo />

	{#if isTokenInvalid}
		<div class="title">{$_('session.reset.password.error.title')}</div>

		<div class="heading">
			{$_('pkg.session.password.reset.invalid.token.error')}
		</div>

		<div class="buttonLink">
			<ButtonLink
				on:click={() => {
					isResetPasswordFormDisplayed = true;
					isAUXModalRendered = false;
				}}>{$_('session.reset.password.error.link')}</ButtonLink
			>
		</div>
	{:else}
		<div class="title">{$_('session.form.reset.password.title')}</div>

		<div class="heading">
			{@html $_('session.reset.password.form.description.svelte', {
				values: { name: $hub.name },
			})}
		</div>

		<form use:form action={`${restApi.apiUrl}/users/password_reset?state=${token}`} method="POST">
			<Input
				type="password"
				name="password"
				label={$_('common.password')}
				invalid={$errors.password?.[0] || submitError}
			/>
			<Button type="submit">{$_('common.continue')}</Button>
		</form>
	{/if}
</div>

<style>
	.resetPasswordForm {
		display: flex;
		box-sizing: content-box;
		flex-direction: column;
		align-items: center;
		padding: var(--gutterLarge);
	}

	.buttonLink {
		font-size: var(--fontSizeSmaller);
	}

	.title {
		font-size: var(--fontSizeLarge);
	}

	form :global(button) {
		inline-size: 100%;
	}

	.heading {
		margin-block: var(--gutterLarge);
		margin-inline: 0;
		color: var(--BLACK);
		font-size: var(--fontSizeNormal);
		font-weight: 500;
		text-align: center;
	}
</style>
